import { FormikHelpers } from "formik";
import { useCreateModelType } from "./api/createModelType";
import ModelTypeForm from "./ModelTypeForm";


const CreateModelType = ({handleCloseModal}: CreateModelTypeProps)  => {
  const createModelTypeMutation = useCreateModelType({data: {}});

  const initialValues: IPostNewModelType = {
    description: "",
    deleted: false
  };

  const handleSubmit = async (values: IPostNewModelType, { setSubmitting }: FormikHelpers<IPostNewModelType>): Promise<void> => {
    try {
      await createModelTypeMutation.mutateAsync({
        data: values,
      });
      handleCloseModal();
    } catch (error) {
      console.log(error);
      console.log("values", values);
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <ModelTypeForm initialValues={initialValues} type="create" onSubmit={handleSubmit} />
  )
}

interface CreateModelTypeProps {
  handleCloseModal: () => void;
}

export default CreateModelType;